import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; declare var $: any;
import { Subject } from 'rxjs';
import { AnnuityItemsViewModel } from '../../../../models/annuity-view.model';
import { DickerSelectListItem, CSPPerpetual_AzureRISubscriptionViewModel, CSPPerpetualItemsViewModel, CspAzureRilist, GetProductPricingV2 } from '../../../../models/csp.model';
import { CommonService } from '../../../../services';
import { ManageService } from '../../../../services/manage.service';
import { CspAzureLocationModel } from '../../../../models/subscription-details-view.model';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';

import { DialogService } from '../../../../services/dialog.service';
import { CSPConditionCheckComponent } from '../../../../popup-collection/csp-condition-check/csp-condition-check.component';


@Component({
  selector: 'app-add-wgs-products',
  templateUrl: './add-wgs-product.component.html',
  styleUrls: ['./add-wgs-product.component.css']
})

export class AddWGSProductsComponent implements OnInit, OnDestroy {
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

  title = 'Add Watchguard Products';
  contentLoaded: boolean = false;
  isLoadingContent: boolean = false;
  hideAddButton = false;
  tenantId: string;
  productType: string;
  setFullWindow = false;
  showSideBar = false;
  sideBarSoftwareSearch = "";
  sideBarSubscriptionSearch = "";
  sideBarAzureRiSearch = "";
 

  defaultMpn: string;
  //Azure Variable
  annuityItems: AnnuityItemsViewModel[] = [];
  azurePlanExist: boolean = false;

  //WGS
  selectedwgsSubscriptionType: string;
  //wgsItemList: string[];
  wgsFamilyList =new Array<string>();
  wgsModelList =new Array<string>();
  

  //Online Service
  searchSubscriotion: string;
  selectedSubscriptionType: string;
  cspItemList: DickerSelectListItem[];
  subscriptionItems: AnnuityItemsViewModel[] = [];
  subscriptionItemsFilter: AnnuityItemsViewModel[] = [];
  subscriptionItemsPendingList: AnnuityItemsViewModel[] = [];
  stockeCodeArray: string[] = [];

  //Azure RI
  azureRiMpnIdSelect: string;
  searchAzureRi: string;
  azureRiUsageSubscriptionList: CSPPerpetual_AzureRISubscriptionViewModel;
  selectedSubscriptionItem: string;
  usageSubscriptionId: string;
  priceList: GetProductPricingV2[];

  locationList: CspAzureLocationModel[];
  selectedLocation: string;
  softwareSubscriptionPendingList: CSPPerpetualItemsViewModel[] = [];

  searchSoftwareSubscription: string;
  checkMpnId: boolean = true;
  isCheck: Boolean;

  //ngunsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  subscriptionType$: Subject<string> = new Subject<string>();

  azureRiLocation$: Subject<string> = new Subject<string>();

  azureRiUsageSubscription$: Subject<string> = new Subject<string>();

  azureRiDurationLoading: boolean = false;

  isLoadingListView = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private manageService: ManageService,
    private cs: CommonService,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) { }

  async ngAfterViewInit(): Promise<void> {
    await this.cs.waitForElm('#levelOne');
    if (!$('#confirmWGSProduct').length) {
      $('#levelOne').animate({ scrollLeft: 1235 }, 400);
    }
  }

  ngOnInit() {
    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
      this.manageService.getCurrentWGSContractResellerId
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(resellerId => {
          if (resellerId) {
            this.isLoadingContent = true;
            this.manageService.GetWGSItems(resellerId)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((res: AnnuityItemsViewModel[]) => {
                           
                 this.wgsFamilyList = [];
                 this.wgsModelList = [];
                 
                  this.subscriptionItems = [ ...res ];      
                  this.subscriptionItems.forEach(sb => {    
                  
                  this.wgsFamilyList.push(sb.secondary_Category);                  
                  this.wgsFamilyList = 
                  this.wgsFamilyList.filter((item, i, arr) => arr.findIndex((t) => t === item) === i);
                  
                  this.wgsModelList.push(sb.tertiary_Category);                  
                  this.wgsModelList = 
                  this.wgsModelList.filter((item, i, arr) => arr.findIndex((t) => t === item) === i);
                      
                  });    

                  this.subscriptionItems.forEach(item => {  
                   
                    if (this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) === 0) {
                      item.disableQty = true;
                    }
                                   

                  });

                     
                  if (this.searchSubscriotion) {
                    this.subscriptionItemsFilter = this.subscriptionItems.filter(annuityItem => annuityItem.description.toLowerCase().includes(this.searchSubscriotion.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchSubscriotion.toLowerCase()));
      
                  } else {
                    this.subscriptionItemsFilter = this.subscriptionItems;
                  }
                 
      
                  // default the min qty
                  this.subscriptionItemsFilter = this.subscriptionItemsFilter.map(item => {
                    item.quantity = '1'
                    return item
                  })
      
                  this.annuityItems = res;
                  this.isLoadingContent = false;
                  this.contentLoaded = true;
                }, (error: any) => {
                  console.info(error);
                  this.isLoadingContent = false;
                  this.contentLoaded = true;
                }
              );
          }
        })

    });

    //clear pending lists
    this.manageService.monitorPendingAzureRi([]);
    this.manageService.monitorPendingSubscriptions([]);
    this.manageService.monitorPendingSoftware([]);

    this.manageService.currentPendingWGSSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: AnnuityItemsViewModel[]) => {
      this.subscriptionItemsPendingList = res;
    },
      (error: any) => {
        console.error(error);
      });

      //this is used for the scrolling the content
      // setTimeout(() => {
      //   this.activatedRoute.paramMap.subscribe(param => {
      //     if (!$('#confirmWGSProduct').length) {
      //       $('#levelOne').animate({ scrollLeft: 1235 }, 400);
      //     }
      //   }
      //   );
      // }, 300);
  }
  onLoading(currentLoadingStatus: boolean) {
    this.isLoadingContent = !currentLoadingStatus;
  }

  isHiddenAddButton(): boolean {
    let isHidden: boolean;
    if (this.subscriptionItemsPendingList.find(item => item.stockGroup === '85CU')) {
      isHidden = true;
    } else {
      isHidden = false;
    }
    return isHidden;
  }

  public filterSubscriptionItems(): void {          
    this.subscriptionItemsFilter = this.subscriptionItems.filter(annuityItem => annuityItem.description.toLowerCase().includes(this.searchSubscriotion.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchSubscriotion.toLowerCase()));    
  }

  /**
   * If min/max qty fields has value then it should validate,
   * if it's empty or 0 then it should not validate.
   */
  public changeQty(annuityItem: AnnuityItemsViewModel): void {
    const min = this.cs.toInteger(annuityItem?.minQty?.replace(',', ''));
    const max = this.cs.toInteger(annuityItem?.maxQty?.replace(',', ''));

    if (min == 0 || this.cs.toInteger(annuityItem.quantity) < min) {
      this.cs.implementToast(`the min qty is ${ min.toString() }`, "Info");
      annuityItem.quantity = min.toString();
    }
    if (max == 0 || this.cs.toInteger(annuityItem.quantity) > max) {
      this.cs.implementToast(`the max qty is ${ max.toString() }`, "Info");
      annuityItem.quantity = max.toString();
    }
  }

  addSubscriptionItem(annuityItem: AnnuityItemsViewModel): void {
    if (annuityItem.attestationRequired) {
      const dialogRef = this.dialog.open(CSPConditionCheckComponent, {
        width: '650px',
      });

      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          //subscription not existing in pendinglist
          annuityItem.totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
          annuityItem.editMPN = true;
          annuityItem.mpn = this.defaultMpn;
          this.subscriptionItemsPendingList.push(new AnnuityItemsViewModel(annuityItem));

          this.manageService.monitorMPNIDCheckStatus(false);
          this.cs.implementToast("Item added successfully", "Success");
          //navigate to product confirm screen
          this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
          this.showSideBarByType();
        }
      })
    } else {
      //subscription not existing in pendinglist
      annuityItem.totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
      annuityItem.editMPN = true;
      annuityItem.mpn = this.defaultMpn;
      this.subscriptionItemsPendingList.push(new AnnuityItemsViewModel(annuityItem));

      this.manageService.monitorMPNIDCheckStatus(false);
      this.cs.implementToast("Item added successfully", "Success");
      //navigate to product confirm screen
      this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
      this.showSideBarByType();
      
      //$('#levelOne').animate({ scrollLeft: 1232 + $('#addWGSProduct').width() }, 400);
    }
  }

  public removeSubscriptionPendingItem(index: number): void {
    this.subscriptionItemsPendingList.splice(index, 1);
    this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  showSideBarByType() {
    if (!this.showSideBar) {
      this.showSideBar = true;
    }
  }

  close() {
    if (this.subscriptionItemsPendingList?.length) {
      this.dialogService.confirm("Leave Site? Changes that you made may not be saved.")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((canLeave: boolean) => {
          if (canLeave) {
            this.manageService.monitorPendingAzureRi([]);
            this.manageService.monitorPendingSubscriptions([]);
            this.manageService.monitorPendingSoftware([]);
            this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/WGS");
            $('#levelOne').animate({ scrollLeft: 250 }, 400);
          }
        });

    } else {
      this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/WGS");
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
    }
  }

  closeSideBar() {
    this.manageService.monitorPendingWGSSubscriptions([]);
    this.manageService.monitorPendingAzureRi([]);
    this.manageService.monitorPendingSubscriptions([]);
    this.manageService.monitorPendingSoftware([]);
    this.showSideBar = false;
    $('#levelOne').animate({ scrollLeft: 250 + $('#addWGSProduct').width() }, 400);
  }

  confirmProduct() {
    this.router.navigate(['ConfirmProducts'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  loadingFamilyItems(event: any): void {   
    this.subscriptionItemsFilter = this.subscriptionItems.
    filter(annuityItem => annuityItem.secondary_Category == event);
  }
  loadingModelItems(event: any): void {
    this.subscriptionItemsFilter = this.subscriptionItems.
    filter(annuityItem => annuityItem.tertiary_Category == event);
  }
}
